import { Router } from '@angular/router';

/** Base route for Users module — supports admin layout and partner portal shell. */
export function getUsersRouteBase(router: Router): string {
  return router.url.includes('/admin/partner-portal')
    ? 'admin/partner-portal/users'
    : 'admin/users';
}
